var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDomino = function SvgDomino(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 82 80"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.25,
    height: 80,
    x: 60,
    fill: "currentColor",
    rx: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 21.25,
    height: 80,
    x: 38.75,
    y: -0.266,
    fill: "currentColor",
    opacity: 0.4,
    rx: 5,
    transform: "rotate(30 38.75 -.266)"
  })));
};
export default SvgDomino;